import { Components as JoyComponents, Theme as JoyTheme } from '@mui/joy';
import JoyCardOverflow, { CardOverflowProps } from '@mui/joy/CardOverflow';

export const overrides: JoyComponents<JoyTheme> = {
  JoyCard: {
    defaultProps: {
      size: 'lg',
    },
    styleOverrides: {
      root: ({ theme }) => ({
        '--Card-radius': theme.radius.md,
      }),
    },
  },
};

export { default as Card } from '@mui/joy/Card';
export { default as CardActions } from '@mui/joy/CardActions';
export const CardOverflow = ({
  bleed = false,
  ...props
}: CardOverflowProps & { bleed?: boolean }) => {
  return (
    <JoyCardOverflow
      {...props}
      sx={{
        ...props.sx,
        ...(bleed && { p: 0 }),
      }}
    />
  );
};
export { default as CardContent } from '@mui/joy/CardContent';
export { default as CardCover } from '@mui/joy/CardCover';
